// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CryptographyOutlinedSvg from "@fishx/icons-svg/es/asn/CryptographyOutlined";
import FishxIcon from '../components/FishxIcon';

var CryptographyOutlined = function CryptographyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CryptographyOutlinedSvg
  }));
};

CryptographyOutlined.displayName = 'CryptographyOutlined';
export default React.forwardRef(CryptographyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CryptographyOutlined.js
// module id = 2349
// module chunks = 0